import RequestHelper, {ActionAnswer, CommandData} from "../utils/RequestsHelper"
import {AxiosPromise} from "axios"
import {StockSettings} from "./StockSettingsApi"
import {SelectProductsState} from "../components/SelectProductsCategoriesOrSets"
import Rule, {IRuleObj} from "../store/entities/rules/Rule"

export default class PriceSettingsApi {
    public static getMarkupsByCategories(): AxiosPromise<ActionAnswer<getMarkupsByCategories>> {
        return RequestHelper.send("get", "priceSettings&action=getCategoriesWithPrices")
    }

    public static saveMarkupData(data: MarkupData): AxiosPromise<ActionAnswer<getMarkupsByCategories>> {
        return RequestHelper.send("post", "priceSettings&action=saveMarkUp", data)
    }

    static deleteMarkupData(param: { type: "old_price" | "price" | "premium_price"; shop_category_id: string }) {
        return RequestHelper.send("post", "priceSettings&action=deleteMarkUp", param)
    }

    public static setProductSyncBy(value: string): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("post", "priceSettings&action=productSyncBy", {value})
    }

    public static getProductSyncBy(): AxiosPromise<ActionAnswer<string>> {
        return RequestHelper.send("get", "priceSettings&action=productSyncBy")
    }

    public static setProductCollectionSettings(data: SelectProductsState): AxiosPromise<ActionAnswer<number>> {
        return RequestHelper.send("post", "priceSettings&action=productCollectionSettings", {value:data})
    }

    public static setHistoryDaysKeep(value: number): AxiosPromise<ActionAnswer<number>> {
        return RequestHelper.send("post", "priceSettings&action=historyDaysKeep", {value})
    }

    public static getHistoryDaysKeep(): AxiosPromise<ActionAnswer<number>> {
        return RequestHelper.send("get", "priceSettings&action=historyDaysKeep")
    }

    public static getSettings(): AxiosPromise<ActionAnswer<priceSettings>> {
        return RequestHelper.send("get", "priceSettings")
    }

    public static comparePrices(pagination: {page:number, pageCount:number, filter?:boolean, with_diff?:boolean, query?:string, start?:boolean}): AxiosPromise<ActionAnswer> {
        return RequestHelper.send("get", "priceSettings&action=comparePrices", pagination)
    }
}

interface getMarkupsByCategories {
    markups: MarkupByCategoryTree[]
    syncPrice: CommandData
    units: { label: string, value: string }[]
    settings: {}
}

export interface priceSettings {
    productCollectionSettings: SelectProductsState
    productSyncBy: string
    // defaultStockCount: number
    historyDaysKeep: number
    prices: IRuleObj[]
}

export interface IComparePrice {
    product_id: string
    offer_id: string
    shop_sku_id: string
    product_name: string
    shop_price: number
    ozon_price: number
    shop_old_price: number
    ozon_old_price: number
}

export interface MarkupByCategoryTree {
    id: string
    name: string
    parent_id: string
    categories: { [id: string]: MarkupByCategoryTree }

    markups: {
        price: MarkupData,
        premium_price: MarkupData,
        old_price: MarkupData
    }
}

export type prices = "old_price" | "price" | "premium_price"

export interface MarkupData {
    include_children: boolean
    shop_category_id: string
    type: prices
    unit: string
    value: string
}
